import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEscrowStatements extends Layout {
    checkboxEmailStatements: Checkbox;
    checkboxIncludeBalanceWhenNoActivity: Checkbox;
    checkboxPageBreakAfterEachEscrowAccount: Checkbox;
    checkboxPageBreakAfterEachPayee: Checkbox;
    checkboxPrintBannerPage: Checkbox;
    excludabletextboxGLAccounts: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    sourceEscrowStatements: DataSource;
    textboxDate: Textbox;
    textboxGroupBy: Textbox;
}
